import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "@/hooks/translation";
import styles from "./fineprint.module.scss";

export default function FinePrint({ className }) {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <p className={cx(styles.fineprint, className)}>{t(`premium.disclaimer`)}</p>
    </div>
  );
}

FinePrint.propTypes = {
  className: PropTypes.string
};
